import { render } from "./AddField.vue?vue&type=template&id=1a59b7c2&scoped=true"
import script from "./AddField.vue?vue&type=script&lang=js"
export * from "./AddField.vue?vue&type=script&lang=js"

import "./AddField.vue?vue&type=style&index=0&id=1a59b7c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a59b7c2"]])

export default __exports__